import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    zIndex: 1,
    display: 'grid',
    placeItems: 'center',
    height: 'calc(128px - 32px)',
    padding: '12px',
    backgroundColor: 'white',
    boxShadow: ({ noShadow }) =>
      noShadow ? '0' : '0 20px 30px rgba(0, 0, 0, 0.16)',
    borderBottom: ({ noShadow }) => (noShadow ? 'solid 1px lightgrey' : '0')
  },

  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%'
  },

  row: {
    display: 'flex',
    alignItems: 'center',
    height: '40px',
    gap: '0.5rem',

    '& .title': {
      width: '100%',
      maxWidth: '73px',
      fontSize: theme.size.base,
      color: '#1F1F1F'
    },

    '&:first-child': {
      marginBottom: '16px'
    }
  },

  topFilter: {
    margin: '0',
    fontSize: theme.size.base,
    color: '#1F1F1F'
  }
}))

export default useStyles
